module.exports = __webpack_public_path__ + "static/media/599.7554(22).9f5f916c.pdf";